export const storeManageListNewData = [
  {
    id: 'baseInfo',
    title: '',
    footerShow:'save',
    data: [
      {
        id: 'trccjxdcb_tr_zyczbk',
        name: '中央财政拨款(万元)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'id11',
        tips:''
      },
      {
        id: 'trccjxdcb_tr_dfczbk',
        name: '地方财政拨款(万元)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
        tips:''
      },
      {
        id: 'trccjxdcb_tr_cczbkwqtsrzh',
        name: '除财政拨款外其他收入总和(万元)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_tr_yjszb',
        name: '研究生学历人数占总在编在岗人员的比重(%)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_szhjyfxcpbhzgwws',
        name: '数字化及预防性藏品保护珍贵文物数(件/套)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_szhjyfxcpbhybwws',
        name: '数字化及预防性藏品保护一般文物数(件/套)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_hxqkxslwsl',
        name: '核心期刊学术论文数量(篇)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_fhxqkxslwsl',
        name: '非核心期刊学术论文数量(篇)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_xszzsl',
        name: '学术专著(译著、编著)数量(本)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_cbjcsl',
        name: '出版教材数量(本)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_yjxtlsl',
        name: '研究性图录数量(本)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_kpdwsl',
        name: '科普读物数量(本)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_bgycdlzzbgzcdzs',
        name: '本馆原创的临展在本馆展出的总数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_bgyczlfswzcdzs',
        name: '本馆原创展览赴省外展出的总数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_bgyczlfswzczsc',
        name: '本馆原创展览赴省外展出总时长(小时)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_sdjpclzrwgs',
        name: '十大精品陈列展入围个数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_szhzldfwl',
        name: '数字化展览的访问量(次)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_yysbjjyszdkyjd',
        name: '拥有省部级及以上重点科研基地(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
      tips:''
      },
      {
        id: 'trccjxdcb_cc_yfxbhdxgsbyfjjsyf',
        name: '预防性保护的相关设备研发及技术研发(项)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_yfxbhbzdzd',
        name: '预防性保护标准的制定(项)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_ygngspbwgrcjlzrc',
        name: '与国内高水平博物馆人才交流总人次(人次)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_yjwbwgrcjlzrc',
        name: '与境外博物馆人才交流总人次(人次)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_jndxssxrs',
        name: '接纳大学生实习人数(人)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_jbsyzfjjldzlgs',
        name: '本馆在境外举办属于政府间交流(公益性)的展览个数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_jbsyzfjjldzlcgrc',
        name: '本馆在境外举办属于政府间交流(公益性)的展览参观人次(万人次)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_jwzlzsyzfjjlzlgs',
        name: '本馆引入境外展览中属于政府间交流(公益性)展览个数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_bgyrjwzlcgrc',
        name: '本馆引入境外展览参观人次(万人次)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_cygjwhychzhjlcs',
        name: '参与国际文化遗产合作和交流次数：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_dzxbwgywzdrypxcs',
        name: '对中小(非国有)博物馆业务指导人员培训次数(次)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_mxgzjbbwgjypxbs',
        name: '面向公众举办博物馆教育培训班数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_mxgzjypxbcjrc',
        name: '面向公众教育培训班参加人次(人次)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_slsbjjysjyjds',
        name: '设立省部级及以上教育基地数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_wccphgjjjxdzls',
        name: '文创产品获国家级奖项的种类数(种)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_wccphsbjjxdzls',
        name: '文创产品获省部级奖项的种类数(种)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_bwgzyzfwdzsc',
        name: '博物馆志愿者服务的总时长(小时)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_zyzgzhgjjjxs',
        name: '志愿者工作获国家级奖项数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_zyzgzhsbjjxs',
        name: '志愿者工作获省部级奖项数(个)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_gjmtmtbdpl',
        name: '国际媒体媒体报道评论(条)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
 tips:''
      },
      {
        id: 'trccjxdcb_cc_gngjjmtbdpl',
        name: '国内国家级媒体报道评论(条)：',
        placeholder: '',
        type: 'number',
        checkType: '',
        newDisabled: false,
        newShow: true,
        ifEdit:false,
        value: '',
        options: [],
        expand: {},
        hasupload:'',
        jpath:'',
        tips:''
      },
    ]
  }
];
